// import * as api from '@/api/homepage';
import diamond from '@/static/imgs/diamond.svg';
// import { useRequest } from 'ahooks';
import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import { useState } from 'react';

const DrppPopover = () => {
  const [isB] = useState(false);
  console.log(isB);

  // useRequest(api.getHasDashboard, {
  //   onSuccess(result) {
  //     setIsB(result.has_joined_dashboard);
  //   },
  // });

  const items: MenuProps['items'] = [
    {
      key: 1,
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="/workspace/"
          className="text-15px"
        >
          会员中心
        </a>
      ),
    },
    {
      key: 2,
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://dashboard.mediecogroup.com/"
          className="text-15px"
        >
          机构工作台
        </a>
      ),
    },
  ];

  return (
    <div>
      {isB ? (
        <Dropdown
          overlayStyle={{ width: 180 }}
          menu={{ items }}
          placement="bottomLeft"
          // arrow
        >
          <span className="flex items-center space-x--10px text-hex-1D2129 relative cursor-pointer">
            <img
              src={diamond}
              className="w-14px mr-12px"
              alt="科研医生工作台"
            />
            <span>会员中心</span>
          </span>
        </Dropdown>
      ) : (
        <a
          className="flex items-center space-x--10px text-hex-1D2129 relative cursor-pointer"
          target="_blank"
          href="/workspace/"
        >
          <img src={diamond} className="w-14px mr-12px" alt="科研医生工作台" />
          <span>会员中心</span>
        </a>
      )}
    </div>
  );
};

export default DrppPopover;
